// extracted by mini-css-extract-plugin
module.exports = {"aux-slot":"AuxiliarySlot_aux-slot__nOaBk"};